import React from 'react';

const UpdateProduct = () => {
    return (
        <div>
            <h1>Coming soon </h1>
        </div>
    );
};

export default UpdateProduct;